import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixTipsStaffV1TipStaffServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/tips-staff-service',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/tips-staff-service',
        destPath: '',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/_api/tips-staff-service',
        destPath: '',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/_api/tips-staff-service',
        destPath: '',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/_api/tips-staff-service',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/tips-staff',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_ecom_tippable-staff';

/**
 * Retrieves a list of up to 100 staff who are eligible to receive tips, given
 * the provided filtering.
 */
export function listTippableStaff(payload: object): RequestOptionsFactory<any> {
  function __listTippableStaff({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.tips.staff.v1.staff',
      method: 'GET' as any,
      methodFqn: 'wix.tips.staff.v1.TipStaffService.ListTippableStaff',
      packageName: PACKAGE_NAME,
      url: resolveWixTipsStaffV1TipStaffServiceUrl({
        protoPath: '/v1/eligible-staff',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __listTippableStaff;
}
